"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ExceptionTypeEnum;
(function (ExceptionTypeEnum) {
    ExceptionTypeEnum["platformComponentElement"] = "platformComponentElement";
    ExceptionTypeEnum["platform"] = "platform";
    ExceptionTypeEnum["componentElement"] = "componentElement";
    ExceptionTypeEnum["component"] = "component";
    ExceptionTypeEnum["service"] = "service";
    ExceptionTypeEnum["generic"] = "generic";
    ExceptionTypeEnum["serverErrorResponse"] = "serverErrorResponse";
    ExceptionTypeEnum["connectionProblem"] = "connectionProblem";
    ExceptionTypeEnum["unableToParseServerResponse"] = "unableToParseServerResponse";
})(ExceptionTypeEnum || (ExceptionTypeEnum = {}));
exports.default = ExceptionTypeEnum;
//# sourceMappingURL=ExceptionTypeEnum.js.map